<template>
    <div v-if="tableData.length > 0" class="actual-cases rounded-bottom mt-md-4">
        <b-table-simple responsive>
            <b-thead>
                <b-tr>
                    <b-th>#</b-th>
                    <b-th>Create<br> Date</b-th>
                    <b-th>Customer<br> Name</b-th>
                    <b-th>Comms <br>Payout ID</b-th>
                    <b-th>Product Details</b-th>
                    <b-th>Pre <br>Sales (RM)</b-th>
                    <b-th>Actual <br>Sales (RM)</b-th>
                    <b-th>Comm.<br> Rate (%)</b-th>
                    <b-th>Pre Rev.(RM)</b-th>
                    <b-th style="background-color: lightblue;">Actual Rev.(RM)</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, index) in tableData" :key="index">
                    <b-td>{{ index + 1 }}</b-td>
                    <b-td v-if="item.case_recognize">{{ item.case_recognize.created_at | dateFormatString }}</b-td>
                    <b-td class="text-break" style="white-space: normal;" v-if="item.case">{{ item.case.prod_customer_name }}</b-td>
                    <b-td><a href="#" @click.prevent="openView(item)">
                        #<span class="name text-primary">{{ item.comms_payout_summary_id }}</span>
                    </a></b-td>
                    <b-td v-if="item.case.prod_details">
                        <div>{{ item.case.prod_type }}</div>
                        <div>{{ item.case.prod_details.prod_pm_project_name }}</div>
                        <div>{{ item.case.prod_details.prod_pm_property_type }}</div>
                        <div>{{ item.case.prod_details.prod_pm_unit_no }}</div>
                    </b-td>
                    <b-td>{{ item.cps_develop_nett_price | moneyFormatter }}</b-td>
                    <b-td>{{ item.cps_actual_develop_nett_price | moneyFormatter }}</b-td>
                    <b-td>{{ item.cps_service_type_percentage }}</b-td>
                    <b-td>{{ item.cps_total_revenue_point | moneyFormatter }}</b-td>
                    <b-td style="background-color: lightblue;">{{ item.cps_actual_total_revenue_point | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr class="font-weight-600">
                    <b-td colspan="5">Total</b-td>
                    <b-td>{{ total.pre_nett_price | moneyFormatter }}</b-td>
                    <b-td>{{ total.actual_nett_price | moneyFormatter }}</b-td>
                    <b-td></b-td>
                    <b-td>{{ total.pre_total_revenue_point | moneyFormatter }}</b-td>
                    <b-td style="background-color: lightblue;">{{ total.actual_total_revenue_point | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr>
                    <b-td colspan="6"></b-td>
                    <b-td colspan="2" class="text-right">
                        Revenue Payout
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512" style="cursor: pointer" @click="togglePayout"><path class="text-primary" fill="currentColor" d="M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56Zm0 82a26 26 0 1 1-26 26 26 26 0 0 1 26-26Zm48 226h-88a16 16 0 0 1 0-32h28v-88h-16a16 16 0 0 1 0-32h32a16 16 0 0 1 16 16v104h28a16 16 0 0 1 0 32Z"/></svg>
                    </b-td>
                    <b-td class="font-weight-600">{{ total.pre_total_revenue_point * revenue_distribution_settings.direct_payout_percentage / 100 | moneyFormatter }}</b-td>
                    <b-td class="font-weight-600">{{ total.actual_total_revenue_point * revenue_distribution_settings.direct_payout_percentage / 100 | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr>
                    <b-td colspan="6"></b-td>
                    <b-td colspan="2" class="text-right">
                        Revenue Pool
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512" style="cursor: pointer" @click="togglePool"><path class="text-primary" fill="currentColor" d="M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56Zm0 82a26 26 0 1 1-26 26 26 26 0 0 1 26-26Zm48 226h-88a16 16 0 0 1 0-32h28v-88h-16a16 16 0 0 1 0-32h32a16 16 0 0 1 16 16v104h28a16 16 0 0 1 0 32Z"/></svg>
                    </b-td>
                    <b-td class="font-weight-600">{{ total.pre_total_revenue_point * revenue_distribution_settings.pool_payout_percentage / 100 | moneyFormatter }}</b-td>
                    <b-td class="font-weight-600">{{ total.actual_total_revenue_point * revenue_distribution_settings.pool_payout_percentage / 100 | moneyFormatter }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <!-- Modal Revenue Payout -->
        <modal :show.sync="modals.revenue_payout" modalClasses="modal-hide-footer" bodyClasses="pt-0">
            <h3 slot="header" class="mb-0 font-weight-500">Revenue Payout</h3>
            <p class="text-muted">
                Total Actual RP X Payout = Revenue Payout
            </p>
            <p class="font-weight-600">
                {{ total.actual_total_revenue_point | moneyFormatter }} X {{revenue_distribution_settings.direct_payout_percentage}}% = {{ total.actual_total_revenue_point * revenue_distribution_settings.direct_payout_percentage / 100 | moneyFormatter }}
            </p>
        </modal>

        <!-- Modal Revenue Pool -->
        <modal :show.sync="modals.revenue_pool" modalClasses="modal-hide-footer" bodyClasses="pt-0">
            <h3 slot="header" class="mb-0 font-weight-500">Revenue Pool</h3>
            <p class="text-muted">
                Total Actual RP X Pool = Revenue Pool
            </p>
            <p class="font-weight-600">
                {{ total.actual_total_revenue_point | moneyFormatter }} X {{revenue_distribution_settings.pool_payout_percentage}}% = {{ total.actual_total_revenue_point * revenue_distribution_settings.pool_payout_percentage / 100 | moneyFormatter }}
            </p>
        </modal>

        <PayoutDetailsModal 
            :showDirectPayoutDetails.sync="modals.showDirectPayoutDetails" 
            :current_comms_payout_summaries="current_view"
            :comms_payout_summaries="comms_payout_summaries"
            @close-modal="modals.showDirectPayoutDetails=false"
            :decide_mode="decide_mode"
            :permission="false"
        />
    </div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useHubStore } from '@/stores/hubStore'
import PayoutDetailsModal from "@/views/Commission/Hub/HubProfile/CenterProfileDetails/PayoutDetailsModalV2";

export default {
    props: ['hub_id', 'hub_team_id', 'revenue_distribution_settings'],
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        PayoutDetailsModal,
    },
    data() {
        return {
            tableData: [],
            modals: {
                revenue_payout: false,
                revenue_pool: false,
                showDirectPayoutDetails: false,
            },
            total: [],
            current_view: [],
            decide_mode: false,
            comms_payout_summaries: [],
        }
    },
    computed: {
        ...mapState(useHubStore,['date_picked'])
    },
    watch: {
        async date_picked(newValue) {
            if(newValue)
            {
                const postData = {
                    'hub_id': this.hub_id,
                    'hub_team_id': this.hub_team_id,
                    'status': 'Approved',
                    'start_date': newValue[0],
                    'end_date': newValue[1],
                }

                try {
                    const res = await this.getCommsPayoutSummaryList(postData)
                    this.tableData = res.comms_payout_summaries
                    this.total = res.total
                } catch (error) {
                    // Handle any errors that might occur during the API call
                    console.error("Error fetching data:", error);
                }
            }
        },
    },
    async created() {
        const postData = {
            'hub_id': this.hub_id,
            'hub_team_id': this.hub_team_id,
            'start_date': this.date_picked[0] ?? null,
            'end_date': this.date_picked[1] ?? null,
            'status': 'Approved',
        }
        const res = await this.getCommsPayoutSummaryList(postData)
        this.tableData = res.comms_payout_summaries
        this.total = res.total
    },
    methods: {
        ...mapActions(useHubStore,['getCommsPayoutSummaryList']),
        togglePool() {
            this.modals.revenue_pool = !this.modals.revenue_pool
        },
        togglePayout() {
            this.modals.revenue_payout = !this.modals.revenue_payout
        },
        openView(row) {
            this.modals.showDirectPayoutDetails = true;
            this.current_view = row;
            this.comms_payout_summaries = [row];
        },
    }
}
</script>